export const getFilterData = (gender = "male") => {
  const minAge = gender?.toLowerCase() === "female" ? 21 : 18;
  const maxAge = 70;

  return [
    {
      id: "age",
      label: "Age",
      type: "slider",
      slider: { min: minAge, max: maxAge },
    },
    {
      id: "height",
      label: "Height",
      type: "slider",
      slider: { min: 100, max: 230 },
    },
    {
      id: "weight",
      label: "Weight",
      type: "slider",
      slider: { min: 30, max: 150 },
    },
    {
      id: "joining_period",
      label: "Joining Period",
      type: "tags",
      tags: [
        { id: 1, label: "Within a day" },
        { id: 2, label: "Within a week" },
        { id: 3, label: "Within a month" },
      ],
    },
    {
      id: "last_active",
      label: "Last Active",
      type: "tags",
      tags: [
        { id: 1, label: "Within a day" },
        { id: 2, label: "Within a week" },
        { id: 3, label: "Within a month" },
      ],
    },
    {
      id: "plan_access",
      label: "Plan Access",
      type: "tags",
      tags: [
        { id: 1, label: "Free plan access" },
        { id: 2, label: "Premium plan access" },
      ],
    },
    {
      id: "verification_status",
      label: "Verification Status",
      type: "tags",
      tags: [
        { id: 1, label: "ID verification" },
        { id: 2, label: "Manual verification" },
      ],
    },
    {
      id: "photo_settings",
      label: "Photo Settings",
      type: "tags",
      tags: [
        { id: 0, label: "Not matter" },
        { id: 1, label: "Visible to all" },
        { id: 2, label: "Without photo" },
        { id: 3, label: "Protected photo" },
      ],
    },
    {
      id: "annual_income",
      label: "Annual Income",
      type: "tags",
      tags: [],
    },
    {
      id: "community",
      label: "Community",
      type: "tags",
      tags: [],
    },
    {
      id: "nationality",
      label: "Nationality",
      type: "tags",
      tags: [],
    },
    {
      id: "state",
      label: "State",
      type: "tags",
      tags: [],
    },
    {
      id: "city",
      label: "District",
      type: "tags",
      tags: [],
    },
    {
      id: "marital_status",
      label: "Marital status",
      type: "tags",
      tags: [],
    },
    {
      id: "family_status",
      label: "Family status",
      type: "tags",
      tags: [],
    },
    {
      id: "family_type",
      label: "Family type",
      type: "tags",
      tags: [],
    },
    {
      id: "body_type",
      label: "Body type",
      type: "tags",
      tags: [],
    },
    {
      id: "qualification",
      label: "Qualification",
      type: "tags",
      tags: [],
    },
    {
      label: "Course",
      id: "education",
      type: "tags",
      tags: [],
    },
    {
      id: "profession",
      label: "Profession",
      type: "tags",
      tags: [],
    },
    {
      id: "drink_filter",
      label: "Drinking",
      type: "select",
      hidden: true,
      tags: [
        { id: 1, label: "Yes" },
        { id: 2, label: "No" },
        { id: 3, label: "Occasionally" },
      ],
    },
    {
      label: "Any health/disability issues?",
      id: "disability_filter",
      type: "select",
      hidden: true,
      tags: [
        { id: "Yes", label: "Yes" },
        { id: "No", label: "No" },
      ],
    },
    {
      label: "Smoking",
      id: "smoke_filter",
      type: "select",
      hidden: true,
      tags: [
        { id: 1, label: "Yes" },
        { id: 2, label: "No" },
        { id: 3, label: "Occasionally" },
      ],
    },
    {
      label: "Complexion",
      id: "complexion",
      type: "tags",
      tags: [],
    },
    {
      label: "Diet",
      id: "diet",
      type: "tags",
      tags: [],
    },
    {
      label: "Mother tongue",
      id: "motherTongue",
      type: "tags",
      hidden: true,
      tags: [],
    },
    {
      label: "Profiles sort by",
      id: "sort_by_filter",
      type: "select",
      hidden: true,
      tags: [
        { id: 1, label: "Latest profile" },
        { id: 0, label: "Not matter" },
      ],
    },
    {
      label: "Location sort by",
      id: "location_filter",
      type: "tags",
      hidden: true,
      tags: [
        {
          label: "Same district",
          id: 1,
        },
        {
          label: "Same state",
          id: 2,
        },
      ],
    },
  ];
};

export const selectedListData = [
  {
    title: "Recently viewed",
    desc: "Profiles that you recently viewed.",
  },
  {
    title: "Career matches",
    desc: "Personalized matches based on your preferences.",
  },
  {
    title: "Professional matches",
    desc: "Find matches with similar career and educational backgrounds.",
  },
  {
    title: "Similar matches",
    desc: "Explore similar profiles with qualities and preferences.",
  },
];

export const FILTER_QUERY_PARAMS = [
  "age",
  "height",
  "weight",
  "joining_period",
  "last_active",
  "plan_access",
  "verification_status",
  "photo_settings",
  "annual_income",
  "community",
  "nationality",
  "state",
  "city",
  "marital_status",
  "family_status",
  "family_type",
  "body_type",
  "qualification",
  "profession",
  "disability_filter",
  "drink_filter",
  "smoke_filter",
  "complexion",
  "diet",
  "education",
  "motherTongue",
  "sort_by_filter",
  "location_filter",
];

export const NON_FILTER_QUERY_PARAMS = ["k", "st", "tab"];
